
export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="col-span-1 md:col-span-2">
            <h3 className="text-2xl font-bold mb-4">
              <span className="text-teal-600">AI FU</span>
              <span className="text-white">nnel</span>
            </h3>
            <p className="text-gray-300 mb-6 max-w-md">
              AI 기반 마케팅 퍼널 자동 생성 플랫폼으로 비즈니스 성장을 가속화하세요. 
              데이터 기반의 최적화된 마케팅 전략을 제공합니다.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-teal-600 transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-teal-600 transition-colors cursor-pointer">
                <i className="ri-twitter-fill text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-teal-600 transition-colors cursor-pointer">
                <i className="ri-linkedin-fill text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-teal-600 transition-colors cursor-pointer">
                <i className="ri-instagram-fill text-lg"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-semibold mb-4">제품</h4>
            <ul className="space-y-2">
              <li><a href="#" className="text-gray-300 hover:text-white transition-colors cursor-pointer">퍼널 생성기</a></li>
              <li><a href="#" className="text-gray-300 hover:text-white transition-colors cursor-pointer">분석 도구</a></li>
              <li><a href="#" className="text-gray-300 hover:text-white transition-colors cursor-pointer">A/B 테스트</a></li>
              <li><a href="#" className="text-gray-300 hover:text-white transition-colors cursor-pointer">통합 기능</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-4">지원</h4>
            <ul className="space-y-2">
              <li><a href="#" className="text-gray-300 hover:text-white transition-colors cursor-pointer">도움말 센터</a></li>
              <li><a href="#" className="text-gray-300 hover:text-white transition-colors cursor-pointer">문의하기</a></li>
              <li><a href="#" className="text-gray-300 hover:text-white transition-colors cursor-pointer">커뮤니티</a></li>
              <li><a href="#" className="text-gray-300 hover:text-white transition-colors cursor-pointer">API 문서</a></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © 2024 FunnelMaster. 모든 권리 보유.
          </p>
          <div className="flex items-center space-x-6 mt-4 md:mt-0">
            <a href="/privacy-policy" className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer">
              개인정보처리방침
            </a>
            <a href="/terms-of-service" className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer">
              이용약관
            </a>
            <a href="https://readdy.ai/?origin=logo" className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer">
              Website Builder
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
